import t from '@jetshop/intl';
import Image from '@jetshop/ui/Image/Image';
import { Price } from '@jetshop/ui/Price';
import ProductLink from '@jetshop/ui/ProductLink';
import { css, cx } from 'linaria';
import React from 'react';
import { theme } from '../Theme';
import { toRem } from '../../helpers';

const wrapperStyling = css`
  font-size: 1rem;
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  background: ${theme.colorScheme.white};
  box-shadow: 0 0 0 1px ${theme.colorScheme.lightgrey};

  a {
    text-decoration: none;
    color: inherit;
  }
  a::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .product-listitem-detail {
    background: white;
    padding: 1rem;
    line-height: 1.35;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;

    h3 {
      font-weight: 600;
      font-size: 0.75em;
    }

    h4 {
      font-weight: normal;
      font-size: 1em;
      color: ${theme.colorScheme.mediumgrey};
    }
  }
  .product-listitem-image {
    flex: 0 0 125px;
    padding-bottom: 0 !important;
  }
  .package-badge {
    background: black;
    color: white;
    font-size: 14px;
    padding: 3px 6px;
  }
  .price-package-wrapper {
    display: flex;
    align-items: baseline;
    .package-price-label {
      font-size: 12px;
      color: grey;
      margin-left: 5px;
    }
  }
  .product-listitem-price-cart-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }
  .discount-badge {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .badge-top-right {
    top: 3em;
  }
  .product-listitem-price {
    font-size: 16px;
    font-weight: bold;
    margin-right: 0.25rem;
    display: flex;
    flex-direction: column-reverse;
  }
  .new-price {
    color: ${theme.colorScheme.red};
  }
  .old-price {
    font-size: ${toRem(12)};
    font-weight: normal;
  }
`;

export function ProductListItem({
  product,
  className,
  imageAspect = '1:1',
  imageSizes = [100, 100, 100, 100],
  forwardRef,
  as: Tag = 'li',
  children,
  loadImageEagerly = false,
  ...linkProps
}) {
  const hasImages = product.images && product.images.length > 0;
  let badges = [...product.badges];
  product.isPackage &&
    badges.push({
      location: 'TOP_RIGHT',
      name: 'Package',
      text: t('Package'),
      style: 'package-badge'
    });

  return (
    <Tag
      className={cx('product-listitem', wrapperStyling, className)}
      data-testid="product"
      data-product-listitem
      ref={forwardRef}
    >
      {hasImages && product.images.length ? (
        <Image
          className="product-listitem-image"
          sizes={imageSizes}
          alt={product.images[0].alt}
          src={product.images[0].url}
          modifiedDate={product.images[0].modifiedDate}
          cover
        />
      ) : (
        <Image
          className="product-listitem-image"
          cover
          sizes={imageSizes}
          src={theme.imageFallback}
          aspect={imageAspect}
          critical={loadImageEagerly}
        />
      )}
      <div className="product-listitem-detail">
        <header>
          <ProductLink product={product} {...linkProps}>
            <h3>{product.name}</h3>
          </ProductLink>
        </header>
        <footer className="product-listitem-footer">
          <div className="product-listitem-price-cart-wrapper">
            <div className="price-package-wrapper">
              {product.price ? (
                <>
                  <Price
                    className="product-listitem-price"
                    price={product.price}
                    previousPrice={product.previousPrice}
                  />
                </>
              ) : null}
            </div>
          </div>
        </footer>
      </div>
    </Tag>
  );
}
export default ProductListItem;
